<style scoped>
    input{
        border: 1px solid #ced4da;
    }

    .wrapper{
        position: relative;
    }

    .loading{
        opacity: 0.5;
        pointer-events: none;
    }

    .loader {
        height: 100px;
        width: 100%;
        text-align: center;
        padding: 1em;
        display: inline-block;
        vertical-align: top;
        z-index: 20;
        position: absolute;
        margin: 100px auto;
    }

    /*
      Set the color of the icon
    */

    svg path,
    svg rect {
        fill: #0162A7;
    }
</style>

<script>
    import axios from 'axios';

    export default {
        data: function () {
            return {
                account : {
                    email : '',
                    username : '',
                    password : '',
                    host : '',
                    port : '',
                    encryption : '',
                },
                errors :  {
                    email : '',
                    username : '',
                    password : '',
                    host : '',
                    port : '',
                    encryption : '',
                },
                loading: false
            }
        },
        mounted: function () {

        },
        methods: {
            handleSMTPFormSubmit(e){
                e.preventDefault();
                this.clearErrors();
                this.loading = true;

                axios.post('/user/email', this.account)
                    .then(res => {
                        if(res.data.created === true){
                            this.$emit('success', null);
                        }
                        this.loading = false;
                    }).catch((err) => {
                        let errors = err.response.data.errors;
                        Object.keys(errors).forEach((key) => {
                            this.errors[key] = errors[key][0];
                        });
                        this.loading = false;
                });

            },

            clearErrors(){
                this.errors = {
                    email : '',
                    username : '',
                    password : '',
                    host : '',
                    port : '',
                    encryption : '',
                };
            }
        }
    }
</script>

<template>
    <div class="wrapper">

        <div v-if="loading" class="loader">
            <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 width="40px" height="40px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
                  <path fill="#000" d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z">
                      <animateTransform attributeType="xml"
                                        attributeName="transform"
                                        type="rotate"
                                        from="0 25 25"
                                        to="360 25 25"
                                        dur="0.6s"
                                        repeatCount="indefinite"/>
                  </path>
                  </svg>
        </div>


        <form v-bind:class="{ loading: loading }" @submit="handleSMTPFormSubmit">
            <div class="form-group">
                <label> {{ $t('email_address') }}</label>
                <input v-model="account.email" class="form-control" placeholder="SMTP email">
                <small v-if="errors.email.length" class="form-text text-danger">{{errors.email}}</small>
            </div>

          <div class="form-group">
            <label> {{ $t('username') }}</label>
            <input v-model="account.username" class="form-control" :placeholder="$t('smtp_username')">
            <small v-if="errors.username.length" class="form-text text-danger">{{errors.username}}</small>
          </div>

            <div class="form-group">
                <label>{{ $t('password') }}</label>
                <input v-model="account.password" type="password" class="form-control" placeholder="SMTP account password">
                <small v-if="errors.password.length" class="form-text text-danger">{{errors.password}}</small>
            </div>

            <div class="form-group">
                <label>{{ $t('host') }}</label>
                <input v-model="account.host" type="text" class="form-control" :placeholder="$t('smtp_host')">
                <small v-if="errors.host.length" class="form-text text-danger">{{errors.host}}</small>
            </div>

            <div class="form-group">
                <label>{{ $t('port') }}</label>
                <input v-model="account.port" type="text" class="form-control" placeholder="SMTP Port">
                <small v-if="errors.port.length" class="form-text text-danger">{{errors.port}}</small>
            </div>

            <div class="form-group">
                <label>{{ $t('encryption') }}</label>
                <select v-model="account.encryption" class="form-control">
                    <option value="">{{ $t('none') }}</option>
                    <option value="1">SSL</option>
                    <option value="0">TLS</option>
                </select>
                <small v-if="errors.encryption.length" class="form-text text-danger">{{errors.encryption}}</small>
            </div>

            <div class="form-group">
                <button type="submit" class="btn btn-primary apply-btn-color">{{ $t('create_account') }}</button>
            </div>
        </form>
    </div>
</template>